<div fxLayout="column" fxLayoutGap="20px" class="layout-padd" fxLayoutAlign="center center" [ngStyle]="{'max-height.px': innerHeight}" fxFlexFill>

    <div fxLayout="row" fxLayoutAlign="center center" class="layout-padd full-w">
        <i class="fas fa-hand-holding-usd primary-ico" style="font-size: 3em;"></i>
    </div>

    <div fxLayoutGap="10px">

        <div fxLayoutAlign="center center" class="text-center layout-padd">
            <span class="mat-subheading">{{'alertminAmountComponent.minAmount' | translate}}</span>
        </div>

        <div fxLayoutAlign="center center">
            <span class="mat-headline">{{miniAmount | priceFilter}}</span>
        </div>

    </div>

    <button mat-stroked-button class="full-w dark-ico" (click)="closeDial()" angulartics2On="click" angularticsAction="closeMiniAmountDial" angularticsCategory="order">
    <span class="mat-title">{{"dialogs.go-back" | translate}}</span>
  </button>


</div>